var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M8.5 15a7 7 0 1 0 0-14 7 7 0 0 0 0 14z",
    fill: "#D01400"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m9.242 8 1.61-1.61a.528.528 0 0 0 0-.742.528.528 0 0 0-.742 0L8.5 7.258l-1.61-1.61a.528.528 0 0 0-.742 0 .528.528 0 0 0 0 .742L7.758 8l-1.61 1.61a.528.528 0 0 0 0 .742.52.52 0 0 0 .371.154.52.52 0 0 0 .371-.154l1.61-1.61 1.61 1.61a.52.52 0 0 0 .371.154.52.52 0 0 0 .371-.154.528.528 0 0 0 0-.742L9.242 8z",
    fill: "#D01400",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseRed);
export default __webpack_public_path__ + "static/media/close_red.d69c984ff4ce7f8f6f29b74f03cc543d.svg";
export { ForwardRef as ReactComponent };